import React from "react";
import { Breadcrumb } from "../../../../atoms/breadcrumb";
import { PAGE_NAME } from "../../../../../constants/constants";
import { useApproverDetailsQuery, useApproverMemberQuery } from "../../../../../store/requestManagement/requestSlice";
import { useLocation, useParams } from "react-router-dom";
import { Skeleton } from "../../../../atoms/skeleton";
import { Divider } from "../../../../atoms/divider";
import { Table } from "../../../../atoms/table";

const ApproverDetails = () => {
  const pageClassName = "p-approverDetails";
  const { state } = useLocation();
  const saasTool = state?.row?.saasTool;
  
  const { id } = useParams();
  const {
    data,
    isLoading,
  } = useApproverDetailsQuery(parseInt(id as string));

  const {
    data: memberOfEntity,
    isLoading: memberOfEntityLoading,
  } = useApproverMemberQuery(
    {
      toolName: saasTool,
      id: id as string,
    },
    {
      skip: (!saasTool && !data?.result?.saasTool) || !id,
    }
  );

  const tableHeader = [
    {
      title: "Serial",
      dataIndex: "id",
      isSortable: false,
    },
    {
      title: "First Name",
      dataIndex: "firstName",
      isSortable: false,
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
      isSortable: false,
    },
    {
      title: "Email",
      dataIndex: "email",
      isSortable: false,
    },
    {
      title: "Role",
      dataIndex: "role",
      isSortable: false,
    },
    {
      title: "Organization",
      dataIndex: "organization",
      isSortable: false,
    },
    {
      title: "PIC",
      dataIndex: "PIC",
      isSortable: false,
    },
  ];
  return (
    <div className={pageClassName}>
      <div className={pageClassName}>
        <Breadcrumb />
        <p className={`${pageClassName}__title`}>
          {PAGE_NAME.MEMBERS}
        </p>
        <div className={`${pageClassName}__container`}>
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              SaaS Name
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {isLoading ? (
                <Skeleton height="small" />
              ) : (
                data?.result?.saasTool ?? "-"
              )}
            </p>
          </div>
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              Type
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {isLoading ? (
                <Skeleton height="small" />
              ) : (
                data?.result?.type ?? "-"
              )}
            </p>
          </div>
          {data?.result?.type !== 'License' && <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              {data?.result?.type ? `${data?.result?.type} Name` : "Name"}
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {isLoading ? (
                <Skeleton height="small" />
              ) : (
                data?.result?.name ?? "-"
              )}
            </p>
          </div>
          }
          <div className={`${pageClassName}__container__item`}>
            <p className={`${pageClassName}__container__item__title`}>
              Number of Members
            </p>
            <p className={`${pageClassName}__container__item__value`}>
              {memberOfEntityLoading ? (
                <Skeleton height="small" />
              ) : (
                memberOfEntity?.result?.length ?? "-"
              )}
            </p>
          </div>

          <Divider />
          <div className={`${pageClassName}__members`}>
            <p className={`${pageClassName}__members__title`}>{data?.result?.type ? `${data?.result?.type} Members` : "Members"}</p>
            <Table
              header={tableHeader}
              data={memberOfEntity?.result ?? []}
              loading={memberOfEntityLoading}
              firstLoad={memberOfEntityLoading}
              sortHandler={() => { }}
              startIndex={1}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproverDetails;